import { Widget, WidgetProps } from "@rjsf/core";

import { FormMessage, Checkbox } from "@xometry/xometry_loft";
import { useState } from "react";

import { MarketplaceOptionGridType } from "../../../schema/generated/schema";
import { getEnumOptions } from "../utils";
import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section, CheckboxGroup } from "./Shared.style";

export const LoftCheckboxGroupField: Widget = ({
  disabled,
  onChange,
  options,
  rawErrors,
  required,
  schema,
  value,
}: WidgetProps) => {
  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);
  const initialValue = value || [];
  const enumOptions = getEnumOptions(schema, options);
  const initialSelectedOptions =
    enumOptions.reduce((selectedOptions, enumOption) => {
      return {
        ...selectedOptions,
        [enumOption.value]: initialValue.includes(enumOption.value),
      };
    }, {}) || [];

  const [selectedOptions, setSelectedOptions] = useState(
    initialSelectedOptions
  );

  let gridCSS = "auto auto";
  if (options.grid === MarketplaceOptionGridType.OneCol) {
    gridCSS = "1fr";
  } else if (options.grid === MarketplaceOptionGridType.TwoCol) {
    gridCSS = "1fr 1fr";
  } else if (options.grid === MarketplaceOptionGridType.ThreeCol) {
    gridCSS = "1fr 1fr 1fr";
  }

  return (
    <div css={Section}>
      <LabelWithOptionalFlag
        required={required}
        htmlFor={options?.name as string}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema.title}
      </LabelWithOptionalFlag>
      <div css={[CheckboxGroup, `grid-template-columns: ${gridCSS}`]}>
        {enumOptions?.map(opt => {
          return (
            <div key={opt.value as string}>
              <Checkbox
                defaultChecked={initialSelectedOptions[opt.value]}
                disabled={disabled}
                name={opt.value as string}
                id={opt?.value as string}
                key={opt?.value as string}
                enterKeyHint="Select"
                onChange={event => {
                  event.stopPropagation();
                  const isChecked = !!event.currentTarget?.checked;
                  const currentSelectedOptions = {
                    ...selectedOptions,
                    [opt.value]: isChecked,
                  };
                  setSelectedOptions(currentSelectedOptions);

                  const selectedOptionsValues = Object.keys(
                    currentSelectedOptions
                  ).filter(key => currentSelectedOptions[key]);
                  onChange(selectedOptionsValues);
                }}
              />
              {opt.label}
            </div>
          );
        })}
      </div>
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
